/* eslint-disable */
export interface DateRange {
  startDate: string;
  endDate: string;
}

// 2. Service Layer - Business Logic
export class TrendsAnalyticsService {
  static calculateTrend(current: number, previous: number): number {
    if (previous === 0) return current > 0 ? 100 : 0;
    return ((current - previous) / previous) * 100;
  }

  static getPreviousDateRange(currentRange: DateRange): DateRange {
    const start = new Date(currentRange.startDate);
    const end = new Date(currentRange.endDate);
    const duration = end.getTime() - start.getTime();

    const previousEnd = new Date(start.getTime() - 1);
    const previousStart = new Date(previousEnd.getTime() - duration);

    return {
      startDate: previousStart.toISOString().split('T')[0]!,
      endDate: previousEnd.toISOString().split('T')[0]!,
    };
  }

  static formatTrendValue(value: number): string {
    const sign = value >= 0 ? '+' : '';
    return `${sign}${value.toFixed(1)}%`;
  }

  static getTrendColorScheme(value: number): string {
    if (value > 0) return 'green';
    if (value < 0) return 'red';
    return 'gray';
  }
}
